export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12856.884fb055.jpg";